import UpdateSettingPage from "./update-setting.page";

export default UpdateSettingPage;
